module.exports = __webpack_public_path__ + "static/media/no_chats_image.7cb34b85.png";